export const environment = {
  production: false,
  apiUrl: 'https://stage.tiecheservice.com/servicecube/index.php/api/'
};

